var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSo = function SvgSo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "so_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-85.3 0h682.6v512H-85.3z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#so_svg__a)",
    transform: "translate(80)scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#40a6ff",
    d: "M-128 0h768v512h-768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M336.5 381.2 254 327.7l-82.1 54 30.5-87.7-82-54.2L222 239l31.4-87.5 32.1 87.3 101.4.1-81.5 54.7z"
  }))));
};
export default SvgSo;